import React, { useEffect, useState } from 'react';

const UpdateBanner = () => {
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    const check = () => {
      const reg = window.swRegistration;
      if (reg && reg.waiting) {
        setWaitingWorker(reg.waiting);
      }
    };

    window.addEventListener('swUpdated', check);
    check();

    return () => {
      window.removeEventListener('swUpdated', check);
    };
  }, []);

  const reload = () => {
    if (!waitingWorker) return;
    waitingWorker.postMessage('SKIP_WAITING');
    waitingWorker.addEventListener('statechange', (e) => {
      if (e.target.state === 'activated') {
        window.location.reload();
      }
    });
  };

  if (!waitingWorker) return null;

  return (
    <div className="fixed bottom-20 inset-x-0 flex justify-center">
      <button onClick={reload} className="px-4 py-2 bg-yellow-400 text-black rounded">
        新しいバージョンがあります。更新
      </button>
    </div>
  );
};

export default UpdateBanner;
